import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { BrandService } from 'shared/brand/brand.service';

import { ScorecardService } from './scorecard.service';


@Injectable()
export class ScorecardsResolver implements Resolve<any> {
  constructor(
    private scorecardService: ScorecardService,
    private brandService: BrandService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    return this.scorecardService.getScorecards(this.brandService.getBrand());
  }
}
